import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { usePixelDestinations } from '@/hooks/account/use-pixel-destinations';
import { useOnboardingFlowStore } from '@/features/setup/stores/use-onboarding-flow-store';

import { checkDestinationConnections } from './use-destination-status';
import { checkIntegrationConnections } from '../helpers/check-integration-connections';

export function useSyncOnboardingState(): void {
  const pixelDestinations = usePixelDestinations();

  const {
    setDataSourceConnected,
    setDataSourceConnection,
    setDestinationConnection,
  } = useOnboardingFlowStore(
    useShallow((s) => ({
      setDataSourceConnected: s.setDataSourceConnected,
      setDataSourceConnection: s.setDataSourceConnection,
      setDestinationConnection: s.setDestinationConnection,
    }))
  );

  useEffect(() => {
    if (pixelDestinations.length === 0) {
      return;
    }

    // Check integrations (data sources)
    const integrations = checkIntegrationConnections(pixelDestinations);
    if (integrations.isShopifyConnected) {
      setDataSourceConnected(true);
    }
    if (integrations.isFacebookAdsConnected) {
      setDataSourceConnection('facebookAds', true);
    }
    if (integrations.isGoogleAdsConnected) {
      setDataSourceConnection('googleAds', true);
    }
    if (integrations.isTiktokAdsConnected) {
      setDataSourceConnection('tiktokAds', true);
    }

    // Check destinations
    const destinations = checkDestinationConnections(pixelDestinations);
    if (destinations.isMetaConnected) {
      setDestinationConnection('metaCapi', true);
    }
    if (destinations.isGoogleConnected) {
      setDestinationConnection('googleAdsCapi', true);
    }
    if (destinations.isTiktokConnected) {
      setDestinationConnection('tiktokEventsApi', true);
    }
    if (destinations.isKlaviyoConnected) {
      setDestinationConnection('klaviyo', true);
    }
  }, [
    pixelDestinations,
    setDataSourceConnected,
    setDataSourceConnection,
    setDestinationConnection,
  ]);
}
